import { useQueryClient } from '@tanstack/react-query'
import { useModal } from '@zet/common/hooks/useModal'
import { useNavigation } from '@zet/common/hooks/useNavigation'

import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { useBrandDetailsById } from '../api/brands/hooks'
import useMissingFieldsSheetStore from '../store/missingFieldsSheet'

const useApplyLink = (
  data,
  partnerId,
  customerName,
  customerId,
  customerPhoneNumber,
  isSourceWeb,
  openConsentBottomSheet?,
  closeConsentBottomSheet?,
  openLinkWithoutModal = false,
  openJFSLinkWithModal = true,
  variantId = undefined
) => {
  const queryClient = useQueryClient()
  const { navigate } = useNavigation()
  const { openModal } = useModal()
  const { data: content } = useBrandDetailsById(partnerId)
  const { customerName: customerNameFromStore } = useAddCustomerStore()
  const { openSheet } = useMissingFieldsSheetStore()
  const handleApply = () => {
    if (data && !data?.shouldPoll) {
      const shareLinkData: any = data
      queryClient.removeQueries({ queryKey: ['shareLink'] })
      if (shareLinkData?.statusCode === 3361) {
        openConsentBottomSheet && openConsentBottomSheet()
        return
      } else {
        closeConsentBottomSheet && closeConsentBottomSheet()
      }
      if (shareLinkData?.statusCode === 3320) {
        navigate('BrandPage', {
          customerId: customerId,
          customerName: customerName || customerNameFromStore,
          customerPhoneNumber: customerPhoneNumber,
          categoryId: content?.categoryId,
          rejectedBrandName: content?.name,
          rejectionReason: shareLinkData?.message,
        })
      } else if (shareLinkData?.statusCode === 3309) {
        openModal('WebFlowSelectorModal', {
          criteriaName: 'applyModal',
          type: 'notEligible',
          brandName: content?.name,
          brandCategoryId: content?.categoryId,
          description: shareLinkData?.message,
        })
      } else if (shareLinkData?.statusCode === 3326) {
        openSheet({
          customerName: customerName || customerNameFromStore,
          customerId,
          brandId: partnerId,
          brandName: content?.name,
          leadSource: isSourceWeb ? 'webBrand' : 'web',
          customerPhoneNumber: customerPhoneNumber,
          variantId,
        })
      } else if (
        (shareLinkData?.url && shareLinkData?.statusCode === 3307) ||
        (shareLinkData?.url && shareLinkData?.statusCode === 3308)
      ) {
        openModal('WebFlowSelectorModal', {
          criteriaName: 'applyModal',
          type: 'missingDetails',
          link: shareLinkData?.url,
          brandName: content?.name,
          brandCategoryId: content?.categoryId,
        })
      } else if (shareLinkData?.statusCode === 3323) {
        openModal('WebFlowSelectorModal', {
          criteriaName: 'applyModal',
          type: 'generic',
          brandName: content?.name,
          brandCategoryId: content?.categoryId,
          description: shareLinkData?.message,
        })
      } else if (shareLinkData?.status === 409) {
        openModal('WebFlowSelectorModal', {
          criteriaName: 'applyModal',
          type: 'leadAlready',
          brandName: content?.name,
          brandCategoryId: content?.categoryId,
        })
      } else {
        if (openLinkWithoutModal && !openJFSLinkWithModal) {
          window.location.href = shareLinkData?.url
        }
        // TODO: Has been hardcode for axis(239). Must be moved to backend
        else if (shareLinkData?.shouldRedirect || String(partnerId) === '239') {
          openModal('WebFlowApplyModal', {
            brandName: content?.name,
            brandLink: shareLinkData?.url,
            brandLogo: content?.logo,
            customerPhoneNumber: customerPhoneNumber,
            modalType: 'redirect',
            brandCategoryId: content?.categoryId,
            openJFSLinkWithModal: openJFSLinkWithModal,
          })
        } else {
          openModal('WebFlowApplyModal', {
            brandName: content?.name,
            brandLink: encodeURIComponent(shareLinkData?.url),
            brandLogo: content?.logo,
            customerPhoneNumber: customerPhoneNumber,
            modalType: 'apply',
            brandCategoryId: content?.categoryId,
            openJFSLinkWithModal: openJFSLinkWithModal,
          })
        }
      }
    }
  }
  return { handleApply }
}

export { useApplyLink }
